function shoppable_video_list() {
    var isUserUnmuted = true;

    setTimeout(() => {
        if(document.querySelector(".shoppable_video_widgets.hide-hidden")){
            document.querySelector(".shoppable_video_widgets.hide-hidden").classList.remove("hide-hidden");
        }    
    }, 2000);
    
    document.querySelectorAll(".shoppable_video_widgets .close_widgets").forEach(btn => {
        btn.addEventListener("click", function () {
            this.closest(".shoppable_video_widgets").classList.add("hide-hidden");
        });
    });
    
    document.querySelectorAll(".shoppable_video_widgets video,.shoppable_video_widgets  .play_icon").forEach(playVideo => {
        playVideo.addEventListener("click", function () {
            this.closest(".shoppable_video_widgets").classList.add("hide-hidden");
            
            if(document.querySelector(".shoppable_video_main.hide-hidden") && document.querySelector(".shoppable_video_overlay.hide-hidden")){
                document.querySelector(".shoppable_video_main.hide-hidden").classList.remove("hide-hidden");
                document.querySelector(".shoppable_video_overlay.hide-hidden").classList.remove("hide-hidden");
                playActiveVideo();
            }
        });
    });
        
    if(document.querySelector(".shoppable_video_main .shoppable_close_popup")){
        document.querySelector(".shoppable_video_main .shoppable_close_popup").addEventListener("click",function(element){
            this.closest(".shoppable_video_main").classList.add("hide-hidden");
            if(document.querySelector(".shoppable_video_overlay")){
                document.querySelector(".shoppable_video_overlay").classList.add("hide-hidden");
            }
            document.querySelector(".shoppable_video_widgets").classList.remove("hide-hidden");

               document.querySelectorAll('.shoppable_video_list video').forEach(video => {
                    video.pause();
                    video.muted = true;
                    video.closest('.video_inner')?.classList.remove('audio');
                });

        });
    }

    function playActiveVideo() {
        var activeVideo = document.querySelector('.shoppable_video_main video');
        activeVideo.currentTime = 0;
        activeVideo.play().catch(() => {});
    }

    document.querySelectorAll('.shoppable_video_list .video_inner video').forEach(video => {
        video.addEventListener('click', function () {
            const wrapper = this.closest('.video_inner');
            const willUnmute = this.muted;

            document.querySelectorAll('.shoppable_video_list video').forEach(_video => {
                _video.muted = true;
                _video.closest('.video_inner')?.classList.remove('audio');
            });

            this.muted = !willUnmute;
            isUserUnmuted = willUnmute;

            if (willUnmute) {
                wrapper.classList.add('audio');
            }
        });
    });

    document.querySelectorAll('.shoppable_video_list .mute_unmute_btn').forEach(media_control => {
        media_control.addEventListener('click', function () {
            const wrapper = this.closest('.video_inner');
            const video = wrapper.querySelector('video');
            const willUnmute = video.muted;

            document.querySelectorAll('.shoppable_video_list video').forEach(_video => {
                _video.muted = true;
                _video.closest('.video_inner')?.classList.remove('audio');
            });

            video.muted = !willUnmute;
            isUserUnmuted = willUnmute;

            if (willUnmute) {
                wrapper.classList.add('audio');
            }
        });
    });
}

document.addEventListener('shopify:section:load', shoppable_video_list);
document.addEventListener('DOMContentLoaded', shoppable_video_list);
